import { Injectable } from "@angular/core";
import { EMPTY } from "rxjs";
import { KeycloakService } from "./keycloak.service";

@Injectable()
export class KeycloakStubService implements KeycloakService {
  init$ = EMPTY;

  get onSuccessRedirectToRedirectUri$() {
    return EMPTY;
  }

  get token() {
    return undefined;
  }

  async signOut() {
    throw new Error("KeycloakStubService");
  }

  async login() {
    throw new Error("KeycloakStubService");
  }
}
